// extracted by mini-css-extract-plugin
module.exports = {"slide":"NoteForm_slide_2MpwF","slide-reverse":"NoteForm_slide-reverse_3qkDt","orderformSection":"NoteForm_orderformSection_y8JF5"};